import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const fmtQty = (n) => (n == null ? "0" : Number(n).toLocaleString("cs-CZ", { maximumFractionDigits: 3 }));

// Odpis (§7) — jen množství a důvod; cíl (zakázka × režie) se odvozuje ze skladu.
export function WriteoffDialog({ item, warehouse, busy, onSubmit, onClose }) {
  const [qty, setQty] = useState("");
  const [note, setNote] = useState("");
  const over = Number(qty) > (item.qty || 0);
  const subtitle = warehouse?.type === "central"
    ? "Odpis jde do režie firmy."
    : `Odpis jde na zakázku ${warehouse?.name || "—"}.`;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto" data-testid="writeoff-dialog">
        <DialogHeader><DialogTitle>Odpis — {item.name}</DialogTitle></DialogHeader>
        <div className="space-y-3.5">
          <p className="text-sm text-muted-foreground">{subtitle} · na skladě {fmtQty(item.qty)} {item.unit}</p>
          <div>
            <Label>Množství * ({item.unit})</Label>
            <Input type="number" step="0.001" value={qty} onChange={(e) => setQty(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="writeoff-qty" />
            {over && <p className="text-xs text-destructive mt-1">Na skladě je jen {fmtQty(item.qty)} {item.unit}.</p>}
          </div>
          <div>
            <Label>Poznámka (důvod odpisu)</Label>
            <Input value={note} onChange={(e) => setNote(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="writeoff-note" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="w-full md:w-auto" onClick={onClose}>Zrušit</Button>
          <Button className="w-full md:w-auto" onClick={() => onSubmit({ qty, note })} disabled={busy || over || !qty} data-testid="writeoff-confirm">
            {busy ? "Ukládám…" : "Odepsat"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
